/* eslint-disable no-param-reassign */
export default class Frames {
    constructor(state) {
        this.state = state;
    }

    start() {
        const newLayer = document.querySelector('.layers__new');
        const layersWrapper = document.querySelector('.layers');
        this.shortcutKeyFrame();

        // add new frame
        newLayer.addEventListener('click', () => {
            this.newFrame();
            this.dagnDrop();
        });

        layersWrapper.addEventListener('click', e => {
            // clone frame
            if (e.target.matches('.clone')) {
                const element = e.target.closest('.layers__item');
                this.cloneFrame(element);
                this.dagnDrop();
            }

            // delete frame
            if (e.target.matches('.trash') && this.state.frames.length > 0) {
                const element = e.target.closest('.layers__item');
                this.deleteFrame(element);
                this.dagnDrop();
            }

            // switch frames
            if (e.target.matches('.layers__item')) {
                document.querySelector('.activ-layer').classList.toggle('activ-layer');
                e.target.closest('.layers__item').classList.toggle('activ-layer');
                const index = e.target.getAttribute('data-layer-num');
                Frames.loadImgOnCanvas(this.state.frames[index]);
            }
        });
    }

    dagnDrop() {
        const dagDrop = document.querySelectorAll('.dragn-drop');
        let stratDropElement;

        dagDrop.forEach(blok => {
            blok.addEventListener(
                'dragstart',
                event => {
                    stratDropElement = event.target;
                    event.target.classList.add('hold');
                },
                false
            );

            blok.addEventListener(
                'dragend',
                e => {
                    e.target.classList.remove('hold');
                },
                false
            );

            blok.addEventListener(
                'dragenter',
                event => {
                    event.preventDefault();
                    event.target.classList.add('hovered');
                    stratDropElement.style.backgroundImage = this.state.frames[
                        event.target.getAttribute('data-layer-num')
                    ];
                    event.target.style.backgroundImage = 'none';
                },
                false
            );

            blok.addEventListener(
                'dragover',
                event => {
                    event.preventDefault();
                    event.target.style.backgroundImage = 'none';
                },
                false
            );

            blok.addEventListener(
                'dragleave',
                event => {
                    event.target.classList.remove('hovered');
                    stratDropElement.style.backgroundImage = 'none';
                    event.target.style.backgroundImage = this.state.frames[
                        event.target.getAttribute('data-layer-num')
                    ];
                },
                false
            );

            blok.addEventListener(
                'drop',
                event => {
                    event.target.classList.remove('hovered');
                    if (stratDropElement === event.target) {
                        stratDropElement.style.backgroundImage = this.state.frames[
                            stratDropElement.getAttribute('data-layer-num')
                        ];
                    } else {
                        const startIndex = stratDropElement.getAttribute('data-layer-num');
                        const endIndex = event.target.getAttribute('data-layer-num');

                        stratDropElement.style.backgroundImage = this.state.frames[endIndex];
                        event.target.style.backgroundImage = this.state.frames[startIndex];

                        [this.state.frames[startIndex], this.state.frames[endIndex]] = [
                            this.state.frames[endIndex],
                            this.state.frames[startIndex]
                        ];

                        document.querySelector('.activ-layer').classList.toggle('activ-layer');
                        event.target.closest('.layers__item').classList.toggle('activ-layer');
                        Frames.loadImgOnCanvas(this.state.frames[endIndex]);
                    }
                },
                false
            );
        });
    }

    static loadImgOnCanvas(imgSrc) {
        const canvas = document.querySelector('.main-canvas');
        const context = canvas.getContext('2d');
        context.clearRect(0, 0, canvas.width, canvas.height);
        const img = new Image();
        img.src = imgSrc.slice(5, -2);
        img.onload = () => {
            context.drawImage(img, 0, 0);
        };
    }

    static renderFramesList(index, frames) {
        const contextHtml = frames
            .map((frame, frIndex) => {
                let classItem = 'layers__item dragn-drop';
                if (+frIndex === +index) {
                    classItem = 'layers__item dragn-drop activ-layer';
                }
                return `<div class="canvas-background"><div class="${classItem}" data-layer-num="${frIndex}" draggable="true" style="background-image:${frame}"><span class="layer-control clone fas fa-clone"></span><span class="layer-control trash fas fa-trash-alt"></span></div></div>`;
            })
            .join('');

        return contextHtml;
    }

    newFrame() {
        const canvas = document.querySelector('.main-canvas');
        const context = canvas.getContext('2d');
        const layersWrapper = document.querySelector('.layers');
        this.state.frames.push(
            `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAALUlEQVRYR+3QQREAAAABQfqXFsNnFTizzXk99+MAAQIECBAgQIAAAQIECBAgMBo/ACHo7lH9AAAAAElFTkSuQmCC')`
        );
        context.clearRect(0, 0, canvas.width, canvas.height);
        document.querySelector('.activ-layer').classList.toggle('activ-layer');
        layersWrapper.innerHTML += `<div class="canvas-background"><div class="layers__item activ-layer dragn-drop" data-layer-num="${this
            .state.frames.length -
            1}" draggable="true"><span class="layer-control clone fas fa-clone"></span><span class="layer-control trash fas fa-trash-alt"></span></div></div>`;
    }

    cloneFrame(element) {
        const layersWrapper = document.querySelector('.layers');
        let index = +element.getAttribute('data-layer-num');
        this.state.frames.splice(index, 0, this.state.frames[index]);
        index += 1;
        const {
            state: { frames }
        } = this;
        layersWrapper.innerHTML = Frames.renderFramesList(index, frames);
        Frames.loadImgOnCanvas(this.state.frames[index]);
    }

    deleteFrame(element) {
        const layersWrapper = document.querySelector('.layers');
        let index = element.getAttribute('data-layer-num');
        if (this.state.frames.length !== 1) {
            this.state.frames.splice(index, 1);
            if (+index !== 0) {
                index -= 1;
            }
            const {
                state: { frames }
            } = this;

            layersWrapper.innerHTML = Frames.renderFramesList(index, frames);
            Frames.loadImgOnCanvas(this.state.frames[index]);
        }
    }

    shortcutKeyFrame() {
        window.addEventListener('keyup', e => {
            switch (e.code) {
                case this.state.shortcut.newFrame: {
                    this.newFrame();
                    this.dagnDrop();
                    break;
                }
                case this.state.shortcut.dublicateFrame: {
                    const element = document.querySelector('.activ-layer');
                    this.cloneFrame(element);
                    this.dagnDrop();
                    break;
                }
                case this.state.shortcut.deleteFrame: {
                    const element = document.querySelector('.activ-layer');
                    this.deleteFrame(element);
                    this.dagnDrop();
                    break;
                }
                default: // do nothing
            }
        });
    }
}
